import {UserAccountApi} from '@frontend/api/UserAccountApi'
import {appUrl} from '@frontend/AppUrl'
import {AsyncDataLoading} from '@frontend/components/AsyncDataLoading'
import type {ReactNode} from 'react'
import {Navigate} from 'react-router-dom'
import {Loading} from 'swayok-react-mdb-ui-kit/components/Loading/Loading'
import {useApiGetRequest} from 'swayok-react-mdb-ui-kit/helpers/api/useApiGetRequest'

interface Props {
    clientSurveyPageUrl: string
    children: ReactNode | ReactNode[]
}

// Проверка данных пользователя на наличие активного контракта и заполненность анкеты.
export function ProtectClientSurveyInnerRoute(props: Props) {
    const {
        clientSurveyPageUrl,
        children,
    } = props

    // Загрузка данных пользователя.
    const {
        data: user,
        isLoading,
        error,
        reload: reloadUserData,
    } = useApiGetRequest(
        abortController => UserAccountApi.getUserDataForAdvancePayment(false, abortController)
    )

    if (isLoading || !user) {
        return (
            <Loading
                loading={true}
                showDelay={2000}
            />
        )
    }

    return (
        <AsyncDataLoading
            loading={isLoading}
            error={!!error}
            onReload={reloadUserData}
            loadedData={user}
            loadingShowDelay={2000}
            render={user => {
                if (!user.crmClientRegistration.finished) {
                    // Анкета не завершена: возвращаем на страницу анкеты.
                    return (
                        <Navigate to={clientSurveyPageUrl} />
                    )
                }
                if (user.details.activeContract || !user.details.canRequestAdvancePayment) {
                    // Уже имеется активный контракт или пользователю не разрешено создавать заявки:
                    // переходим на страницу контракта.
                    return (
                        <Navigate to={appUrl().cabinet.advancePayments.contract} />
                    )
                }
                return (
                    <>{children}</>
                )
            }}
        />
    )
}
